export default "__VITE_ASSET__B1khBmSj__"